import React, { useState } from 'react';
import { Button, Modal, Segment, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { ErrorSegment, ReportForm, VideoPlayer } from '../../..';
import { Consts, Styles } from '../../../../res';
import PresentValues from '../../../../res/pdfs/presentvalues.pdf';
import { findNextFreqExam, resolveExam } from '../../../../helpers/examHelpers';
// import QuestionTranslationModal from '../QuestionTranslationModal';

const { solidBtn } = Styles;

const ExamFooter = ({ onFlagQuestion, onFavQuestion, Q, Qindex, isMockExam, summary, showTutorial, setShowTutorial,
    isViewOnly, onSelectQuestion, questions, additionalStyles, t, userOnFinishExam, onGoingExam }) => {
    const { FooterButtonStyle } = styles;
    const isArabic = i18next.language === 'ar';
    const [showExplanation, setShowExplanation] = useState(false);
    const [showReportIssue, setShowReportIssue] = useState(false);
    const [showFinishConfirm, setShowFinishConfirm] = useState(false);
    const [showFinishAllConfirm, setShowFinishAllConfirm] = useState(false);
    const [showMoveToNextSection, setShowMoveToNextSection] = useState(false);
    // const [showTranslationModal, setShowTranslationModal] = useState(false);

    if (!Q) return null;

    const questionsWithOutCmaFacts = questions.filter(q => !q?.showFactOnly);
    const solved = questionsWithOutCmaFacts.reduce((acc, q) => !!(q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS ? q.answerOptionId : q.answerText) + acc, 0) || 0;
    const flagged = questionsWithOutCmaFacts.reduce((acc, q) => (q.isFlagged) + acc, 0) || 0;

    let nextExam;
    if (onGoingExam.examType === Consts.EXAM_TYPES.FREQ && !isViewOnly) {
        const nextFreq = onGoingExam && findNextFreqExam(onGoingExam?.parentId, onGoingExam?.orderNum);
        nextExam = onGoingExam && resolveExam(onGoingExam?.examType, null, nextFreq?.id);
    }

    const onNextClick = () => {
        if (Qindex === questions.length - 1) {
            if (nextExam) setShowMoveToNextSection(true);
            return;
        }
        if (window.ExamNav)
            window.ExamNav.goTo(Qindex + 1);
        onSelectQuestion(questions[Qindex + 1]);
    };

    const onBackClick = () => {
        if (window.ExamNav)
            window.ExamNav.goTo(Qindex - 1);
        onSelectQuestion(questions[Qindex - 1]);
    };

    return (
        <Segment inverted basic style={{ backgroundColor: '#4c4c4c', ...additionalStyles, width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <div >
                    {!isMockExam && (Q.answerText || Q.answerOptionId || isViewOnly) ? <Button icon='video play' labelPosition='left' content={t('Explanation')} onClick={() => setShowExplanation(true)} style={FooterButtonStyle} /> : null}
                    {!isMockExam && <Icon size='large' title={t('ReportProblem')} name='exclamation triangle' color='red' link onClick={() => setShowReportIssue(true)} />}
                    <Icon size='large' title={t('Filters')} name='grid layout' link onClick={() => summary.setShowSummary(true)} className='tw-text-white' />
                    {!showTutorial && isMockExam && !isViewOnly && <Icon size='large' title={t('Tutorial')} name='question circle' link onClick={() => setShowTutorial(true)} className='tw-text-white' />}

                </div>

                <div style={{ textAlign: 'center' }}>
                    {/* <Button icon='translate' content={t('Translate')} style={FooterButtonStyle} onClick={() => setShowTranslationModal(true)}/> */}
                    <a title={t('PresentValueTable')} href={PresentValues} rel='noreferrer' target='_blank'>
                        <Button content={t('PresentValueTable')} style={FooterButtonStyle} />
                    </a>
                </div>

                <div style={{ textAlign: 'right' }}>
                    {!Q?.showFactOnly && <Button icon={Q.isFlagged ? 'flag outline' : 'flag'} onClick={() => onFlagQuestion(Q)} style={FooterButtonStyle} />}
                    {!Q?.showFactOnly && !isMockExam && <Button icon={Q.isFav ? 'star' : 'star outline'} onClick={() => onFavQuestion(Q)} style={FooterButtonStyle} />}
                    <Button.Group>
                        <Button disabled={Qindex <= 0} onClick={onBackClick} content={t('Back').toUpperCase()} style={{ ...FooterButtonStyle, width: '6rem', marginLeft: 5, marginRight: 5, clipPath: isArabic ? 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)' : 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)' }} />
                        <Button disabled={(isViewOnly || !isMockExam || !nextExam) && Qindex >= questions.length - 1} onClick={onNextClick} content={t('Next').toUpperCase()} style={{ ...FooterButtonStyle, width: '6rem', marginLeft: 5, marginRight: 5, clipPath: isArabic ? 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)' : 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)' }} />
                    </Button.Group>
                </div>
            </div>

            <Modal
                onClose={() => setShowExplanation(false)}
                open={showExplanation}
                content={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? <VideoPlayer kind={Consts.VIDEOS_KINDS.EXPLANATION} videoDetails={{ ...Q.correctAnswer.explanations.videos[0], ...Q }} onClose={() => setShowExplanation(false)} /> : <ErrorSegment text={t('ComingSoon')} icon='wait' />}
                basic={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? true : false}
                size='large'
                centered
                closeIcon={!(Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length)}
                closeOnDimmerClick={false}
            />

            <Modal
                onClose={() => setShowReportIssue(false)}
                open={showReportIssue}
                content={<ReportForm reportOn={Consts.REPORTS_TYPES.QUESTION} reportLink={Q} id={Q.questionId} showModal={setShowReportIssue} />}
                closeIcon
                header={t('ReportProblem')}
                size='small'
                centered
                closeOnDimmerClick={false}
            />

            <Modal
                size='mini'
                open={showFinishConfirm}
                header={<div className='tw-text-white tw-bg-[#4c4c4c] tw-p-2'>{t('CmaConfirmFinish')}</div>}
                content={<div className='tw-grid tw-text-center tw-p-5 tw-gap-5 tw-my-5'>
                    <div><Icon name='exclamation triangle' size='huge' className='tw-text-GOLD' /></div>
                    <div>
                        {
                            flagged > 0 ? <p> {t("CmaFinishExamNotAllQuestionswithFlags")} </p> : <p>{t("CmaFinishExamNotAllQuestionsNoFlags")}</p>
                        }
                    </div>
                    <p>{t("CmaAreYouSureFinishExam")}</p>

                    <div>
                        <Button icon='x' onClick={() => setShowFinishConfirm(false)} content={t("Exit")} style={{ ...solidBtn, backgroundColor: "#8CC63F" }} />
                        <Button icon='check' onClick={() => { setShowFinishConfirm(false); setShowFinishAllConfirm(true); }} content={t("Finish")} style={{ ...solidBtn, backgroundColor: "#8CC63F" }} />
                    </div>
                </div>}
            />
            <Modal
                size='mini'
                open={showFinishAllConfirm}
                header={<div className='tw-text-white tw-bg-[#4c4c4c] tw-p-2'>{t('CmaConfirmFinish')}</div>}
                content={<div className='tw-grid tw-text-center tw-p-5 tw-gap-5 tw-my-5'>
                    <div><Icon name='question circle' size='huge' className='tw-text-PRIMARY_50' /> </div>
                    <div><p>{t("CmaFinishExam")}</p></div>
                    <div>
                        <Button icon='x' onClick={() => setShowFinishAllConfirm(false)} content={t("Exit")} style={{ ...solidBtn, backgroundColor: "#8CC63F" }} />
                        <Button icon='check' onClick={() => { userOnFinishExam(onGoingExam, true); setShowFinishAllConfirm(false); }} content={t("Finish")} style={{ ...solidBtn, backgroundColor: "#8CC63F" }} />
                    </div>
                </div>}
            />

            <Modal
                size='mini'
                open={showMoveToNextSection}
                header={<div className='tw-text-white tw-bg-[#4c4c4c] tw-p-2'>{t('CmaConfirmFinish')}</div>}
                content={<div className='tw-grid tw-text-center tw-p-5 tw-gap-5 tw-my-5'>
                    <div><Icon name='question circle' size='huge' className='tw-text-PRIMARY_50' /> </div>
                    {solved !== questionsWithOutCmaFacts?.length && <div><p>{t("CmaFinishExamNotAllQuestionsNoFlags")}</p></div>}
                    <div><p>{t("CmaAreYouSureFinishExam")}</p></div>
                    <div>
                        <Button icon='x' onClick={() => setShowMoveToNextSection(false)} content={t("Cancel")} style={{ ...solidBtn, backgroundColor: "#8CC63F" }} />
                        <Button icon='check' onClick={() => { userOnFinishExam(onGoingExam); setShowFinishAllConfirm(false); }} content={t("Finish")} style={{ ...solidBtn, backgroundColor: "#8CC63F" }} />
                    </div>
                </div>}
            />


            {/* 
            <QuestionTranslationModal show={showTranslationModal} setShow={setShowTranslationModal} 
                question={Q} lang={isArabic ? 'en' : 'ar'} examRoundId={onGoingExam.examRoundId} /> */}

        </Segment>
    );
};

const styles = {
    FooterButtonStyle: {
        backgroundColor: '#8CC63F',
        color: 'white'
    }
};

export default withTranslation()(ExamFooter);